import { USER_LOGOUT } from "./root.actions";

export const logout = () => ({ type: USER_LOGOUT });
